import React from 'react';
import SideBar from '../../components/modules/left_sidebar';
import NavBar from '../../components/common/navbar';
import RuleMainForm from '../../components/ContaModule/RuleMainForm'
import { withRouter } from 'react-router-dom';
import Footer from '../../components/common/Footer';

const optionMenuArray =
{
    linkData: {
        tableName: "conta",
        TitleBartitle: "Conta Corrente Vínica",
        prevPageName: "",
        prevPageLink: "",
        currentPath: "conta_regras_form/nivel-1",
        TitleBarlogo: "auditing",
    }
}

class ContaRuleForm extends React.Component{

  /* Primeiro passo na acomodação da classe */

  constructor(props) {
    super(props);
    this.state = this.setLinkDataMethod();
}

/* Esta é a primeira etapa após o construxctor para carregar este componente  */

componentDidMount = () => {
    this.setState(this.setLinkDataMethod())
}

/* Esta função irá chamar automaticamente quando o estado da página mudar  */
componentDidUpdate = (prevProps) => {
    const parsed = this.props.location.state && this.props.location.state.paramoption ||{};
    let prevParsed = prevProps.location.state && prevProps.location.state.paramoption || {}
    if ( prevParsed.name !== parsed.name && (!parsed.tableName || parsed.back ||  this.state.search !== window.location.search || this.state.tableName !== parsed.tableName)) {
        this.setState(this.setLinkDataMethod())
    }
}
/*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */
setLinkDataMethod = () => {
    let parsed = this.props.location.state && this.props.location.state.paramoption || {}
    if(Object.keys(parsed).length === 0 && this.state && this.state.parsed){
        parsed = this.state.parsed
    }
    if(parsed.back){
        parsed = {}
    }
    let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
    if(topBarMenu){
        this.setState({topBarMenu})
    }
    if(parsed){
        this.setState({parsed})
    }
    let selectOption = { ...optionMenuArray };
    let linkData = selectOption.linkData;
    if (!parsed.name) {
        linkData.prevPageName = "";
        linkData.prevPageLink = "";
        linkData.tableName = "Conta"
    }
    parsed.name = parsed.name ? parsed.name : ""
    parsed.url = parsed.url ? parsed.url : ""
    parsed.tableName = parsed.tableName ? parsed.tableName : ""
    if (parsed.name) {
        linkData.prevPageName = parsed.name;
        linkData.prevPageLink = parsed.url;
        linkData.tableName = parsed.tableName;
        linkData.prevPageName = parsed.name === 'Regras - Nível 1' ? "Gestão de Regras - Nível 1" 
          : parsed.name === 'Regras - Nível 2' ? "Gestão de Regras - Nível 2" : parsed.name
    }

    return {
        noOption: true,
        popUpForm: null,
        linkData: linkData,
        parsed: parsed,
        tableName: linkData.tableName,
        search: window.location.search,
        topBarMenu:topBarMenu
    }
}

  render(){
    let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu || this.state.topBarMenu
    return(
      <div className="dashboard">
        <NavBar 
          date={new Date()} 
          linkData={this.state.linkData} 
          topBarMenuOption={topBarMenu} 
          noOption={this.state.noOption} 
          moduleName="Conta"
        />
        <SideBar />
        <RuleMainForm linkData={this.state.linkData}  />
        <Footer/>
      </div>
    )
  }
}

export default withRouter(ContaRuleForm);
